import React from "react";
import "./UserCard.css"; // Import CSS file for UserCard component
import img from "../images/img_2.jpg";
import axios from "../axios/axios";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const UserCard = ({
  id,
  username,
  email,
  profilePic,
  yearsOfExperience,
  location,
  cv,
  whoami,
  position,
  onAccept,
  status,
}) => {
  const { id: jobId } = useParams();
  console.log(status);
  const handleAcceptUser = async () => {
    try {
      const { data } = await axios.patch(`/api/company/jobs/${id}/${jobId}`);
      console.log(data.user);
      toast.success("user is accepted!An email is sent to inform him!!");
      onAccept();
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  };
  return (
    <div className="user-card">
      <img
        src={profilePic ? profilePic.url : img}
        className="user-card__image"
      />
      <div className="user-card__description">
        <div className="userD">
          <p>
            <span>Name: </span>
            {username}
          </p>
          <p>
            <span>Position: </span>
            {position}{" "}
          </p>
          <p>
            <span>YearsOfExp: </span>
            {yearsOfExperience}
          </p>
        </div>
        <div className="userD">
          <p>
            <span>Email: </span>
            {email}
          </p>
          <p>
            <span>Location: </span>
            {location}{" "}
          </p>
          <p>
            <span>About: </span>
            {whoami}{" "}
          </p>
        </div>
      </div>
      <div className="buttons">
        <button className="CV">
          {" "}
          <a
            download={cv.url}
            href={cv.url}
            target="_blank"
            style={{ textDecoration: "none", color: "white" }}
          >
            Download CV
          </a>
        </button>
        <button
          disabled={status === "accepted" ? true : false}
          onClick={handleAcceptUser}
          className="acceptUserButton"
        >
          {" "}
          {status === "accepted" ? "accepted" : "Accept User"}
        </button>
      </div>
    </div>
  );
};

export default UserCard;
